/**
 * Calculate distance between two addresses using their lat/lng coordinates
 * Uses Haversine formula
 * @param {Object} origin - { lat, lng }
 * @param {Object} destination - { lat, lng }
 * @returns {number} - Distance in kilometers
 */
export function calculateDistanceKm(origin, destination) {
  if (!origin || !destination) return 0;

  const lat1 = origin.lat || origin.latitude;
  const lng1 = origin.lng || origin.longitude;
  const lat2 = destination.lat || destination.latitude;
  const lng2 = destination.lng || destination.longitude;

  if (!lat1 || !lng1 || !lat2 || !lng2) return 0;

  const R = 6371; // Earth's radius in km
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;

  return Math.round(distance * 100) / 100; // Round to 2 decimal places
}

/**
 * Parse weight from size string (e.g., "Small (Up to 2 kg)" -> 2)
 * @param {string} sizeString - Size description
 * @returns {number} - Weight in kg
 */
export function parseWeightFromSize(sizeString) {
  if (!sizeString) return 1;

  const lowerSize = sizeString.toLowerCase();

  // Try to extract number from format like "Small (Up to 2 kg)"
  const match = sizeString.match(/(\d+(?:\.\d+)?)\s*kg/i);
  if (match) {
    return parseFloat(match[1]);
  }

  // Fallback defaults
  if (lowerSize.includes('small')) return 2;
  if (lowerSize.includes('medium')) return 10;
  if (lowerSize.includes('large')) return 25;
  if (lowerSize.includes('extra')) return 50;

  return 5; // Default fallback
}

/**
 * Format price for display
 * @param {number} price
 * @returns {string}
 */
export function formatPrice(price) {
  if (price == null) return '0';
  return Math.round(price).toString();
}
